import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import moment from 'moment'

import SidePanel from '@root/Auth/Views/SidePanel'
import Compliance from './Compliance'
import Scroll from '@components/Scroll'
import Input from '@components/Form/InputMUI'
import SelectOrInput from '@components/Form/SelectOrInputMUI'
import Checkbox from '@components/Form/CheckboxMUI'
import Phone from '@components/Form/PhoneMUI'
import DatePicker from '@components/Form/DatePickerMUI'

import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import DeleteIcon from '@material-ui/icons/Delete'
import CloseIcon from '@material-ui/icons/Close'
import { MuiThemeProvider } from '@material-ui/core/styles'
import Brightness1 from '@material-ui/icons/Brightness1'
import getCreateBasicProfileValidationSchema from './CreateBasicProfileFormValidationSchema'
import theme from './ComplianceStyles'
import AtheneumPrivacyPolicy_2022July from '../../../public/assets/pdf/AthenumPrivacyPolicy_2022July.pdf'
import AtheneumPrivacyPolicyNotice_2022July from '../../../public/assets/pdf/AtheneumPrivacyPolicyNotice_2022July.pdf'
const steps = [
  'Sign Agreement',
  'Check Profile'
]

class ExpertComplianceAgreement extends Component {
  static propTypes = {
    complianceStore: PropTypes.object,
    growlStore: PropTypes.object,
    isComplianceOk: PropTypes.bool
  }

  constructor(props) {
    super(props)
    extendObservable(this, {
      isSubmitting: false,
      activeStep: this.props.isComplianceOk ? 1 : 0
    })

    this.state = {
      showTrainingVideo: false,
      video_start_time: `0m0s`,
      experienceIndex: 0
    }
  }

  handleAgree = async () => {
    const { growlStore, accept } = this.props
    this.isSubmitting = true
    this.activeStep++

    try {
      await accept()
      this.isSubmitting = false
    } catch (error) {
      this.isSubmitting = false
      growlStore.showError(error)
    }
  }

  handleDisagree = async () => {
    const { decline, growlStore } = this.props

    try {
      await decline()

    } catch (error) {
      growlStore.showError(error)
    }
  }

  handleTrainingVideo = () =>
    this.setState({ showTrainingVideo: true, video_start_time: '0m0s' })

  handleQuizVideo = () =>
    this.setState({ showTrainingVideo: true, video_start_time: '9m4s' })

  closeVideo = () =>
    this.setState(() => ({
      showTrainingVideo: false
    }))
  
  submitForm = async (values, actions) => { 
    const { create, growlStore } = this.props
    this.submitting = true

    try {
      await create(values)
      this.submitting = false
    } catch(err) {
      this.submitting = false
      growlStore.showError(err)
    }
  }

  addNewExperience = (form) => {
    const experience= {
      company: '',
      position: '',
      startDate: new Date().toISOString().substring(0, 10),
      endDate: null,
      description: '',
      current: true
    }

    form.setFieldValue('latestExperiences', [...form.values.latestExperiences, experience])
    const nextIndex = form.values.latestExperiences.length

    this.setState({
      experienceIndex: nextIndex
    })
  }

  deleteExperience = (form) => {
    const latestExperiences = form.values.latestExperiences.filter((experience, index) => index !== this.state.experienceIndex)
    form.setFieldValue('latestExperiences', latestExperiences)
    this.setState({
      experienceIndex: 0
    })
  }

  setCurrentExperience = (index) => {
    this.setState({
      experienceIndex: index
    })
  }

  renderExperienceFields = (form, index) => {
    const { user } = this.props.complianceStore
    const experiences = user.cv?.experiences || []
    const companies = experiences?.map(e => e.company.name) || []
    const positions = experiences?.map(e => e.position.name) || []
    
    if(!form.values.latestExperiences) return null

    return (
       <Grid container item spacing={2} xs={12} className="experience-fields">
          <Grid item xs={12} md={6} className="company">
            <Field
              form={form}
              name={`latestExperiences[${index}].company`}
              label='Company'
              options={companies}
              component={SelectOrInput}
              variant='outlined'
            />
          </Grid>
          <Grid item xs={12} md={6} className="position">
            <Field
              form={form}
              name={`latestExperiences[${index}].position`}
              label='Position'
              options={positions}
              component={SelectOrInput}
              variant='outlined'
            />
          </Grid>
        
          <Grid item xs={12} md={6} className="start-date">
            <Field
              form={form}
              name={`latestExperiences[${index}].startDate`}
              label='From'
              component={DatePicker}
              variant='outlined'
            />
          </Grid>
          <Grid item xs={12} md={4} className="end-date">
            <Field
              form={form}
              name={`latestExperiences[${index}].endDate`}
              label='To'
              component={DatePicker}
              disabled={form.values.latestExperiences[index]?.current || false}
              variant='outlined'
            />
          </Grid>
          <Grid item xs={12} md={2} className="current">
            <Field
              form={form}
              name={`latestExperiences[${index}].current`}
              label='Current'
              component={Checkbox}
              color="primary"
            />
          </Grid>
      
          <Grid item xs={12} className="description">
            <Field
              form={form}
              name={`latestExperiences[${index}].description`}
              label='Brief Position Description'
              multiline
              rows={2}
              variant='standard'
              component={Input}
            />
          </Grid>
      </Grid>
    )
  }

  render() {
    const { lang, complianceStore } = this.props
    const { user } = complianceStore

    if(!user) return null

    const emails = [user.email, ...user.address.emails?.map(e => e.email)]
    const phones = user.address.phones?.map(e => e.phoneNum)

    if(user.expert.phoneNum) {
      phones.unshift(user.expert.phoneNum)
    }

    const phoneTypeId = user.expert.phoneTypeId || 3 // 3: mobile
    const experiences = user.cv?.experiences?.sort((a, b) => moment(b.startDate).diff(a.startDate))

    const latestExperience = {
      company: experiences ? experiences[0].company.name : '',
      position: experiences ? experiences[0].position.name : '',
      startDate: experiences ? experiences[0].startDate : new Date().toISOString().substring(0, 10),
      endDate: experiences ? experiences[0].endDate : null,
      current: experiences ? experiences[0].current : true,
      description: experiences ? experiences[0].description : ''
    }

    if(this.state.showTrainingVideo) {
      return (
          <div className="training-video-modal">
            <CloseIcon  className="closeTrainingVideo" onClick={this.closeVideo}/>
            <div className="training-video-container">
              <iframe
                src={`https://player.vimeo.com/video/588250697?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;h=687cbe2433#t=${this.state.video_start_time}`}
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                title="Insider Trading Training and Quiz for Experts June 23 2021"></iframe>
            </div>
          </div>
      )
    }

    if(!this.state.showTrainingVideo) {
      return (
        <MuiThemeProvider theme={theme}>
          <div className="expert-container expert-compliance">
            <SidePanel />
            <div className="form-expert-compliance">
            <Scroll>
              <div className="compliance-page-wrapper">
              <Grid container item className="stepper-wrapper">
                      <Stepper activeStep={this.activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>

                      {this.activeStep === 0 && (
                        <React.Fragment>
                          <Compliance />
                          <div className="form-footer">
                          <hr className='line-separator'></hr>
                          <Grid container className='privacy-policy-container'>
                            <div>Link to: </div>
                              <Typography
                                className="privacy-policy">
                                <Brightness1 className='bullet-icon' />
                                <u><a href={AtheneumPrivacyPolicy_2022July} style={{color: "#3D44C4"}} download>Privacy Policy</a></u>
                              </Typography>
                              <Typography
                                className="privacy-policy-notice">
                                <Brightness1 className='bullet-icon' />
                                <u><a href={AtheneumPrivacyPolicyNotice_2022July} style={{color: "#3D44C4"}} download>Privacy Policy Notice</a></u>
                              </Typography>
                          </Grid>
                          <hr className='line-separator'></hr>
                            <Grid container className="video-links-container">
                              <Typography
                                className="trainingLinkButton"
                                onClick={this.handleTrainingVideo}>
                                <PlayCircleOutlineIcon className='icon'/>
                                Insider Trading Training
                              </Typography>
                              <Typography
                                className="trainingLinkButton"
                                onClick={this.handleQuizVideo}>
                                  <PlayCircleOutlineIcon className='icon'/>
                                  Quiz on Insider Trading
                              </Typography>
                            </Grid>
                            <hr className='line-separator'></hr>
                          <div className='privacy-additional-text'>By pressing the button "I agree", you accept the Atheneum Expert Agreement and Privacy Policy, after which you woul be able to participate in Atheneum projects.</div>
                          
                            <div className="action-section">
                              <div className="expert-form__footer">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={this.isSubmitting}
                                  onClick={this.handleAgree}>
                                  I Agree
                                </Button>
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  disabled={this.isSubmitting}
                                  onClick={this.handleDisagree}>
                                  Disagree
                                </Button>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      )}

                      {this.activeStep === 1 &&  (
                        <React.Fragment>
                          <Formik
                            enableReinitialize
                            initialValues={{
                              email: emails[0] || '',
                              phoneNum: phones[0] || '',
                              phoneTypeId: phoneTypeId,
                              latestExperiences: [latestExperience]
                            }}
                            isInitialValid={!!emails[0]}
                            validationSchema={getCreateBasicProfileValidationSchema(user, lang)}
                            onSubmit={this.submitForm}
                            render={form => (
                              <div className='expert-form'>
                                <Form onSubmit={form.handleSubmit}>
                                  <Grid container spacing={4}>
                                    <Grid container item xs={12} spacing={2}>
                                      <Grid item xs={12}>
                                        <Typography className="form-group-title">Contact info</Typography>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <Field
                                          name='email'
                                          label='Email'
                                          options={emails}
                                          component={SelectOrInput}
                                          variant="outlined"
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <Field
                                          namePhoneNum='phoneNum'
                                          namePhoneTypeId='phoneTypeId'
                                          label='Phone'
                                          options={phones}
                                          component={Phone}
                                          variant="outlined"
                                        />
                                      </Grid>
                                    </Grid>

                                    <Grid container item spacing={2} xs={12}>
                                      <Grid item>
                                        <Typography 
                                          component="div"
                                          className="form-group-title">
                                          What is your latest experience?
                                        </Typography>
                                      </Grid>

                                      <Grid container item xs={12} spacing={2} className="experience-tabs">
                                        {form.values.latestExperiences.length > 1 && 
                                          form.values.latestExperiences.map((e, index) => {
                                          let className = 'position-tab'
                                          className += index === this.state.experienceIndex ? ' active' : ''

                                          return (
                                            <Typography 
                                              className={className}
                                              component="div"
                                              onClick={() => this.setCurrentExperience(index)}>
                                                {index+1}- {e.position}
                                            </Typography>
                                          )
                                          })
                                        }
                                      </Grid>

                                      {this.renderExperienceFields(form, this.state.experienceIndex)}

                                      <Grid container item xs={12} className="experience-actions">
                                        {form.values.latestExperiences.length > 1 && 
                                        <Grid item className="experience-action">
                                          <DeleteIcon className='icon' />
                                          <Typography 
                                            className="link-button" 
                                            onClick={() => this.deleteExperience(form)}>
                                              Delete experience
                                          </Typography>
                                        </Grid>
                                        }
                                        {form.values.latestExperiences.length === 1 && 
                                          <Grid item></Grid>
                                        }
                                        <Grid item className="experience-action">
                                          <AddCircleIcon className='icon' />
                                          <Typography 
                                            onClick={() => this.addNewExperience(form)}
                                            className="link-button">
                                            Add experience
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  
                                    <Grid item className="profile-form-footer">
                                      <Button
                                        submit
                                        variant="contained"
                                        color="primary"
                                        onClick={form.submitForm}
                                        disabled={form.isSubmitting || !form.isValid}
                                      >Confirm</Button>
                                    </Grid>
                                  </Grid>
                                </Form> 
                              </div>
                            )}
                          />
                        </React.Fragment> 
                      )}
                    </Grid>
                </div>
              </Scroll>
            </div>
          </div>
        </MuiThemeProvider>
    )}
  }
}

export default withRouter(
  inject('complianceStore', 'growlStore')(observer(ExpertComplianceAgreement))
)
